import React, { useState } from "react";
import toast from "react-hot-toast";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography
} from '@mui/material';

export const RedisExpire = () => {
    const [loading, setLoading] = useState(false);
    const [openConfirm, setOpenConfirm] = useState(false);

    const handleConfirmOpen = () => {
        setOpenConfirm(true);
    };

    const handleConfirmClose = () => {
        setOpenConfirm(false);
    };

    const handleFlush = async () => {
        setOpenConfirm(false);
        try {
            setLoading(true);
            const payload = {
                confirm: true,
                scope: "all"
            };

            const res = await fetch(`${process.env.REACT_APP_BASEURL}/admin/redis/flush`, {
                method: "POST",
                headers: { 
                    "Content-Type": "application/json",
                    Authorization: `${localStorage.getItem("astroVani-admin-token")}`,
                },
                body: JSON.stringify(payload),
            });

            if (!res.ok) {
                const errData = await res.json();
                throw new Error(errData?.message || "Failed to flush Redis");
            }

            toast.success("Redis cache flushed successfully!");
        } catch (err) {
            console.error(err);
            toast.error(err.message || "Error flushing Redis cache");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="card-body modern-card p-3">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h5 className="fw-bold m-0">Redis Cache Management</h5>
            </div>
            
            <div className="row">
                <div className="col-12">
                    <div className="alert alert-warning border border-warning" role="alert">
                        <strong>Warning:</strong> Proceeding with this action will clear the entire Redis cache across all scopes. Please note that application performance may experience temporary degradation while the cache is being rebuilt.
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-center mt-4">
                <button
                    type="button"
                    className="btn btn-danger px-4 py-2"
                    onClick={handleConfirmOpen}
                    disabled={loading}
                >
                    {loading ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Flushing...
                        </>
                    ) : (
                        "Flush Redis Cache"
                    )}
                </button>
            </div>

            <Dialog open={openConfirm} onClose={handleConfirmClose} maxWidth="xs" fullWidth>
                <DialogTitle>Confirm Flush</DialogTitle>
                <DialogContent>
                    <Typography>Are you sure you wish to proceed? This action will permanently flush the Redis cache for all operational scopes.</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfirmClose} color="inherit">Cancel</Button>
                    <Button onClick={handleFlush} color="error" variant="contained">Confirm Flush</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default RedisExpire;
